<template>
  <Datepicker 
    :placeholder="'00/00/00'"
    :format="'dd/MM/yy'"
    v-model="date"
    @selected="value => handleChange(value)"
  ></Datepicker>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
export default {
  components: {
    Datepicker
  },
  props: {
    dateAdded: {
      type: [String, undefined],
      required: false,
    },
  },
  data() {
    return {
      date: new Date()
    }
  },
  methods: {
    handleChange(value) {
      this.date = value;
      this.$emit('input', this.date);
    },
  },
  watch: {
    dateAdded(newDateAdded, oldDateAdded) {
      if(newDateAdded!=undefined) {
        this.date = new Date(newDateAdded);
      }
      else{
        this.date = this.date;
      }
    }
  },
}
</script>
<style>
.vdp-datepicker{
  width:40%;
}
.vdp-datepicker input{
  border: none!important;
  height: 35px;
  border-radius: 12px 12px 12px 0px;
  text-align: center;
  width: 100%;
  background: #e4f4f9;
  outline: none;
}
.vdp-datepicker__calendar{
  margin-top: 10px;
  width: 13.5em !important;
}
.vdp-datepicker__calendar header span{
  height: 2.5em !important;
  line-height: 2.5em !important;
  font-size: 14px !important;
  font-weight: bold !important;
  font-family: content !important;
  background-color: #0181A0!important;
  color: white!important;
}
.prev, .next, .day__month_btn {
    background-color: #0181A0!important;
    color: white!important;
}

.vdp-datepicker__calendar header .next:after {
    border-left: 10px solid #fff!important;
    margin-left: 5px;
}

.vdp-datepicker__calendar header .prev:after {
    border-right: 10px solid #fff!important;
    margin-left: -5px;
}

.vdp-datepicker__calendar header .up:not(.disabled):hover{
  background-color: #0181A0!important;
  color: white!important;
}
.vdp-datepicker__calendar .cell{
  font-size: 11.2px !important;
  font-weight: bold !important;
  font-family: content !important;
  color: #1381a2!important;
  padding: 0.3em 0.6em !important;
  height: 30px !important;
  line-height: 1.9em !important;
}
.vdp-datepicker__calendar .cell.day-header{
  color: #454545!important;
}
.vdp-datepicker__calendar .cell.selected{
  color: white!important;
}
</style>